import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowsDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 1V12M15 12L11 8M15 12L19 8M5 1V17M5 17L1 13M5 17L9 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowsDown);
const Memo = memo(ForwardRef);
export default Memo;
